<template>
  <footer class="footBox">
    <div class="content-1200">
      <div class="flex-column">
        <div class="title">服务</div>
        <a class="item" href="/home/service" role="link">金标认证</a>
        <div class="item">
          <el-tooltip effect="light" placement="right">
            <div slot="content" class="info-tooltip">
              <div>邮箱: bd@itgsa.com</div>
              <div>微信: ysq1031111</div>
              <div class="text-center">
                <img src="@/assets/img/common/wxCode2.png" alt="微信咨询"/>
              </div>
            </div>
            <a class="item">金标认证咨询</a>
          </el-tooltip>
        </div>
        <a class="item" href="/home/union/openness" role="link" target="_blank">联盟开放能力</a>
      </div>
      <div class="flex-column">
        <div class="title">友情链接</div>
        <a target="_blank" href="https://open.oppomobile.com/" class="item">OPPO开放平台</a>
        <a target="_blank" href="https://dev.vivo.com.cn/home" class="item">vivo开放平台</a>
        <a target="_blank" href="https://dev.mi.com/" class="item">小米开放平台</a>
        <a target="_blank" href="https://open.lenovomm.com/developer/home" class="item">联想开放平台</a>
      </div>
      <div v-if="docList.length" class="flex-column">
        <div class="title">标准文档</div>
        <a class="item" v-for="(item,index) in docList" :key="index" :href="item.redirectUrl" target="_blank">
          {{ item.title }}
        </a>
      </div>
      <div class="flex-column">
        <div class="title">联系方式</div>
        <a target="_blank" href="https://open.oppomobile.com/" class="item">邮箱 service@itgsa.com</a>
        <a class="item" href="https://weibo.com/7488524033/profile?topnav=1&wvr=6" target="_blank">微博</a>
        <div class="item">
          <el-tooltip effect="light" placement="right">
            <div slot="content" class="info-tooltip">
              <div class="text-center">
                <img src="@/assets/img/common/code.png" alt="微信公众号"/>
              </div>
            </div>
            <a class="item">微信公众号</a>
          </el-tooltip>
        </div>
        <div class="item">
          <el-tooltip effect="light" placement="right">
            <div slot="content" class="info-tooltip">
              <div class="text-center">
                <img src="@/assets/img/common/wxCode.png" alt="官方微信号"/>
              </div>
            </div>
            <a class="item">官方微信号</a>
          </el-tooltip>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import {documentData} from "@/common/VO/homeVO.js";
import {singleHomeSever} from "@/common/api-config";

export default {
  name: "foot",
  data() {
    return {
      documentData: documentData(),
      docList: []
    };
  },
  created() {
    this.queryRecommendList()
  },
  methods: {
    queryRecommendList() {
      singleHomeSever.queryRecommendList({}).then(res => {
        if (res.code == 0) {
          this.docList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.info-tooltip {
  font-size: 14px;

  div:not(:last-of-type) {
    margin-bottom: 12px;
  }

  img {
    width: 100px;
  }
}

.footBox {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background-color: #12151A;

  .content-1200 {
    padding: 80px 0 20px;
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid #333333;

    .flex-column {
      flex: 1;
    }

    .title {
      font-weight: bold;
      font-size: 14px;
      color: #CEC298;
      margin-bottom: 16px;
    }

    .item {
      cursor: pointer;
      color: #666;
      margin-bottom: 20px;
    }
  }
}
</style>
